import { render, staticRenderFns } from "./menu-add-or-update.vue?vue&type=template&id=25bbd667"
import script from "./menu-add-or-update.vue?vue&type=script&lang=js"
export * from "./menu-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./menu-add-or-update.vue?vue&type=style&index=0&id=25bbd667&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports